var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwimmingPool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 249 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 28.8077,
    y1: 71.3574,
    x2: 3.53488,
    y2: 97.6411,
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 35.6356,
    y1: 93.1991,
    x2: 3.53558,
    y2: 125.299,
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 36.7851,
    y1: 120.788,
    x2: 4.68512,
    y2: 152.888,
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 36.7851,
    y1: 150.676,
    x2: 4.68512,
    y2: 182.776,
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 35.6356,
    y1: 181.713,
    x2: 3.53558,
    y2: 213.813,
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 42.5328,
    y1: 205.853,
    x2: 6.9842,
    y2: 241.402,
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 74.7197,
    y1: 205.853,
    x2: 35.7225,
    y2: 244.851,
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 105.757,
    y1: 205.853,
    x2: 66.7599,
    y2: 244.851,
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 165.533,
    y1: 207.003,
    x2: 126.536,
    y2: 246,
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 196.57,
    y1: 205.853,
    x2: 157.573,
    y2: 244.851,
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 244.902,
    y1: 152.974,
    x2: 209.302,
    y2: 189.622,
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 244.902,
    y1: 116.189,
    x2: 209.302,
    y2: 152.837,
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 244.902,
    y1: 81.7034,
    x2: 209.302,
    y2: 118.351,
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 222.879,
    y1: 71.3556,
    x2: 210.449,
    y2: 82.8973,
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 245.931,
    y1: 190.909,
    x2: 189.759,
    y2: 244.92,
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 135.645,
    y1: 205.853,
    x2: 96.6477,
    y2: 244.851,
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 67.875V46.25V30.5C17.0001 15.3122 29.3122 3 44.5001 3V3C59.6879 3 72.0001 15.3122 72.0001 30.5V148.5C72.0001 163.688 59.6879 176 44.5001 176V176H38.198",
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6539 160H45.0001V160C53.2843 160 60.0001 153.284 60.0001 145V32C60.0001 23.7157 53.2843 17 45.0001 17V17C36.7158 17 30.0001 23.7157 30.0001 32V52.75V61.6875V67.1653",
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3982 70H18.1876H11.0001C6.58178 70 3.00006 73.5817 3.00006 78V238C3.00006 242.418 6.58178 246 11.0001 246H238C242.418 246 246 242.418 246 238V78C246 73.5817 242.418 70 238 70H209.723",
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0001 70V198C37.0001 202.418 40.5818 206 45.0001 206H201C205.418 206 209 202.418 209 198V70",
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M207 86.9996C207 86.9996 199.579 80.1218 189.727 80.0016C179.503 79.8769 176.348 87.0608 166.121 86.9996C156.082 86.9395 153.131 80.0016 143.091 80.0016C133.051 80.0016 130.101 86.9996 120.061 86.9996C110.02 86.9996 107.647 80.0016 97.6061 80.0016C87.5657 80.0016 84.0404 86.9996 74.0001 86.9996",
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M207 118C207 118 199.579 112.104 189.727 112.001C179.503 111.894 176.348 118.052 166.121 118C156.082 117.948 153.131 112.001 143.091 112.001C133.051 112.001 130.101 118 120.061 118C110.02 118 107.647 112.001 97.6061 112.001C87.5657 112.001 84.0404 118 74.0001 118",
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6171 116.463C48.4639 118.334 49.8212 111.572 59.668 113.444",
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9344 87.3646C47.3931 89.6859 48.018 82.1696 57.4767 84.4908",
    stroke: "#808080",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwimmingPool);
export default __webpack_public_path__ + "static/media/swimming-pool.31fe9d0da531eb0760abbaacd4edae4b.svg";
export { ForwardRef as ReactComponent };